import TableHeader from "./components/TableHeader";
import TableRow from "./components/TableRow";
import TableBlur from "./components/TableBlur";
import { useCalculatorController } from "../../context/context";
import GratitudeBanner from "../../banners/GratitudeBanner";
import FullMetricReportBanner from "../../banners/FullMetricReportBanner";
import { useMetricTable } from "./useMetricTable";
import styles from "./index.module.scss";

const MetricTable = () => {
  const { controller } = useCalculatorController();
  const { isMetricFormSubmitted, isCalcFormSubmitted, showGratitudeModal } =
    controller;

  const { tableData } = useMetricTable();

  return (
    <div className={styles.modal_root}>
      <div className={styles.table_wrapper}>
        <TableHeader />
        <div className={styles.table_content}>
          <TableBlur />
          <TableRow category="Revenue" data={tableData.revenueRowData} />
          <TableRow
            category="ROAS"
            valueSymbol="%"
            data={tableData.roasRowData}
          />
          <TableRow category="ARPU" data={tableData.arpuRowData} />
          <TableRow category="ARPPU" data={tableData.arppuRowData} />
          <TableRow category="LTV" data={tableData.ltvRowData} />
        </div>

        {(!isMetricFormSubmitted || !isCalcFormSubmitted) && (
          <FullMetricReportBanner />
        )}

        {showGratitudeModal && <GratitudeBanner />}
      </div>
    </div>
  );
};

export default MetricTable;
